import React, {useCallback, useRef, useState} from "react";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import Popup from "../../ui/Popup";
import Input from "../Input";
import {connect} from "react-redux";
import {t} from "../../../components/Translate";
import "./styles.css"
import CalendarDaysIcon from "../../../assets/icons/CalendarDaysIcon";
import SilverButton from "../../buttons/SilverButton";
import colors from "../../../utils/Colors";
import {sameDay} from "../../../utils/General";
import XIcon from "../../../assets/icons/XIcon";

const dateExists = (dates, date) =>
    dates.some(d => sameDay(d, date));

const removeDate = (dates, date) =>
    dates.filter(d => !sameDay(d, date));


const MultiDatePicker = ({
                             value,
                             panelAlign = {horizontal: "left", vertical: ""},
                             user,
                             defaultValue = null,
                             onChange,
                             onReset,
                             disabled = false,
                             inputContainerStyle = {},
                             popupStyle = {},
                             placeholder = null,
                             popupDirection = 'bottom'
                         }) => {

    const [isOpen, setIsOpen] = useState(false);
    const calendarContainerRef = useRef(null);

    const formatDate = (date) => {
        if (Array.isArray(date)) {
            return date
                .filter(Boolean)
                .map(d => {
                    const day = String(d.getDate()).padStart(2, "0");
                    const month = String(d.getMonth() + 1).padStart(2, "0");
                    const year = String(d.getFullYear()).slice(-2);

                    return `${day}.${month}.${year}`;
                })
                .join(", ");
        }
        return ""
    };

    const cleanUpClasses = () => {
        if(calendarContainerRef.current === null) return;

        const dayItems = calendarContainerRef.current.querySelectorAll(".react-calendar__tile");

        dayItems.forEach((item) => {
            if(item.classList.contains("react-calendar__tile--active") && item.classList.contains("react-calendar__tile--not-active")) {
                item.classList.remove("react-calendar__tile--active");
                item.blur()
            }
        })

    }

    const handleClickDay = (date) => {
        setTimeout(()=>{
            cleanUpClasses()
        },100)
        if (!Array.isArray(value)) {
            onChange([date]);
            return;
        }

        if (dateExists(value, date)) {
            onChange(removeDate(value, date));
        } else {
            onChange([...value, date]);
        }
    };

    const tileClassName = useCallback((arg) => {
        if (!Array.isArray(value)) return null;
            return dateExists(value, arg.date)
                ? "react-calendar__tile--active"
                : "react-calendar__tile--not-active";
    },[value]);

    const showResetButton = () => {
        if (!defaultValue) return value !== null && value.length > 0;
        if (Array.isArray(defaultValue)) {
            return value && defaultValue.some((v, index) => v.getTime() !== value[index].getTime);
        }
        return false;
    }

    return (
        <Popup
            trigger={
                <div className="date-picker-input-container" style={{...inputContainerStyle}}>
                    <Input
                        value={formatDate(value)}
                        style={{cursor: disabled ? "not-allowed" : "pointer", height: "100%"}}
                        placeholder={t({text: placeholder ? placeholder : 'date', user})}
                        leadingIcon={
                            <CalendarDaysIcon
                                width={18}
                                height={18}
                                className="date-picker-input-icon"
                            />
                        }
                        readOnly
                        disabled={disabled}
                    />

                    {
                        onReset && showResetButton() &&
                        <SilverButton
                            variant="ghost"
                            className="date-picker-reset-button"
                            width={'24px'}
                            height={'24px'}
                            onClick={e => {
                                e.stopPropagation();
                                onReset()
                            }}
                            disabled={disabled}
                        >
                            <XIcon width={16} height={16} style={{color: colors.silverDark}} stroke="currentColor"/>
                        </SilverButton>
                    }
                </div>
            }
            direction={popupDirection}
            panelAlign={panelAlign}
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            disabled={disabled}
            style={{...popupStyle}}
        >
            <div className="date-picker-popup-container" ref={calendarContainerRef}>
                <Calendar
                    // key={value} // needs this for re-render the component and calculate classes from zero because not able to remove active class with this setup
                    locale={user.language}
                    onClickDay={handleClickDay}
                    tileClassName={tileClassName}
                    value={null}
                />
            </div>
        </Popup>
    );
};

const mapSateToProps = state => ({
    user: state.user,
});

export default connect(mapSateToProps)(MultiDatePicker)



// WEBPACK FOOTER //
// ./src/components-new/form/DatePicker/MultiDatePicker.jsx